<template>
  <v-container class="page">
    <v-card
      width="100%"
      style="border-radius:10px;"
      class="pa-3"
    >
      <v-card-title class="title font-weight-light">
        Popular Address Management
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <v-card-text>
        <div class="d-flex">
          <v-btn
            color="#00ACDC"
            dark
            class="mb-2 ml-auto"
            @click="createDialog = true"
          >
            CREATE POPULAR ADDRESS
          </v-btn>
        </div>
        <v-data-table
          :headers="headers"
          :items="dataApi"
          item-key="book_id"
          class="font-weight-light"
          :loading="loadingAddr"
          loading-text="Loading..."
          :footer-props="footerProps"
          @update:options="updatePaging"
          :server-items-length="popularAddressTotal"
          :options.sync="paginationOptions"
        >
          <template #[`item.no`]=" { item }">
            {{ ((paginationOptions.page - 1) * paginationOptions.itemsPerPage) + dataApi.indexOf(item) + 1 }}
          </template>
          <template #[`item.created_at`]=" { item }">
            {{ dateFormat(item) }}
          </template>
          <template #[`item.action`]="{ item }">
            <v-icon
              small
              color="green"
              @click="editItem(item)"
              class="mr-2"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              color="red"
              @click="declineItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template #[`item.map`]="{ item }">
            <v-icon
              small
              color="blue"
              @click="handleMap(item)"
            >
              mdi-eye
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="showMap"
      width="700"
      @click:outside="handleClickDialogOutside"
    >
      <v-card
        style="border-radius:10px;"
        class="pa-10"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="#00ACDC"
                size="40"
              >
                mdi-map-marker
              </v-icon>
              {{ map.name }} Map
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card-text class="my-0">
          <GmapMap
            :style="map.style"
            ref="gmap"
            :center="map.center"
            :zoom="map.zoom"
            :options="map.options"
          >
            <GmapMarker
              :position="map.position"
              :clickable="true"
              :draggable="false"
            />
          </GmapMap>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deldialog"
      persistent
      max-width="560"
    >
      <v-card
        dark
        color="red"
      >
        <v-card-title>
          <span>
            <v-icon>mdi-alert-circle</v-icon> Are you sure to want to delete
            this popular address?
          </span>
        </v-card-title>
        <v-card-text>
          You will delete this popular address permanently.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="deldialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
            @click="submitDeletePopular()"
            :loading="loadingUpdate"
            :disabled="loadingUpdate"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="createDialog"
      max-width="700"
      width="650px"
      persistent
      scrollable
    >
      <v-card
        width="100%"
        style="border-radius:10px;"
        class="pa-10"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="#00ACDC"
                class="mx-2"
              >
                mdi-map-marker-plus
              </v-icon>Create
              Address
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card-text class="my-0">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Popular Address Name"
                    :rules="[(v) => !!v || 'Address is required']"
                    v-model="create.address"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-autocomplete
                    v-model="destination.selected"
                    :items="destination.locations"
                    :loading="destination.loading"
                    :no-filter="true"
                    :search-input.sync="destination.search"
                    hide-selected
                    hide-no-data
                    hide-details
                    clearable
                    item-text="address"
                    item-value="address"
                    label="Find Location"
                    append-icon=""
                    outlined
                    return-object
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Longitude"
                    :rules="[(v) => !!v || 'Longitude is required']"
                    v-model="create.longitude"
                    readonly
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Latitude"
                    :rules="[(v) => !!v || 'Latitude is required']"
                    v-model="create.latitude"
                    readonly
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <GmapMap
                    :style="mapCreate.style"
                    :center="mapCreate.center"
                    :zoom="mapCreate.zoom"
                    :options="mapCreate.options"
                    :clickable="true"
                    @click="handleClickMap"
                  >
                    <GmapMarker
                      :position="mapCreate.position"
                      :clickable="true"
                      :draggable="false"
                    />
                  </GmapMap>
                </v-col>
                <!-- <v-col cols="12" sm="12">
                  <v-text-field
                    outlined
                    hide-details
                    label="Latitude"
                    placeholder="e.g. -35.12880410"
                    :rules="[(v) => !!v || 'Latitude is required']"
                    v-model="create.latitude"
                    required
                  />
                </v-col> -->
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="close"
                block
                type="submit"
                color="error"
              >
                CLOSE
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="save"
                block
                type="submit"
                color="success"
                :loading="loadingUpdate"
                :disabled="loadingUpdate"
              >
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editDialog"
      max-width="700"
      width="650px"
      persistent
      scrollable
    >
      <v-card
        width="100%"
        style="border-radius:10px;"
        class="pa-10"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="green"
                class="mx-2"
              >
                mdi-map-marker-plus
              </v-icon>Update
              Address
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card-text class="my-0">
          <v-form
            ref="formEdit"
            v-model="validEdit"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Address Name"
                    :rules="[(v) => !!v || 'Address is required']"
                    v-model="edit.address"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Longitude"
                    placeholder="e.g. 147.40314925"
                    :rules="[(v) => !!v || 'Longitude is required']"
                    v-model="edit.longitude"
                    disabled
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Latitude"
                    placeholder="e.g. -35.12880410"
                    :rules="[(v) => !!v || 'Latitude is required']"
                    v-model="edit.latitude"
                    disabled
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-autocomplete
                    v-model="destinationEdit.selected"
                    :items="destinationEdit.locations"
                    :loading="destinationEdit.loading"
                    :no-filter="true"
                    :search-input.sync="destinationEdit.search"
                    hide-selected
                    hide-no-data
                    hide-details
                    clearable
                    item-text="address"
                    item-value="address"
                    label="Find Location"
                    append-icon=""
                    outlined
                    return-object
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <GmapMap
                    :style="mapEdit.style"
                    :center="mapEdit.center"
                    :zoom="mapEdit.zoom"
                    :options="mapEdit.options"
                    :clickable="true"
                    @click="handleClickMap($event, false)"
                  >
                    <GmapMarker
                      :position="mapEdit.position"
                      :clickable="true"
                      :draggable="false"
                    />
                  </GmapMap>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="closeEdit"
                block
                type="submit"
                color="error"
              >
                CLOSE
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="saveEdit"
                block
                type="submit"
                color="success"
                :loading="loadingUpdate"
                :disabled="loadingUpdate"
              >
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
const qs = require("qs");
import isNull from 'lodash/isNull';
import isEmpty from 'lodash/isEmpty';
// import isUndefined from "lodash/isUndefined";
import { gmapApi } from "vue2-google-maps";
import moment from "moment";

export default {
  data: () => ({
    token: "",
    clientid: "",
    reason: "",
		dataPool: [],
    createDialog: false,
    destination: {
      search: null,
      timeout: null,
      loading: false,
      locations: [],
      selected: {},
    },
    destinationRequired: false,
    destinationEdit: {
      search: null,
      timeout: null,
      loading: false,
      locations: [],
      selected: {},
    },
    destinationEditRequired: false,
    rules: [(v) => !!v || "Please Complete Field"],
    headers: [
      {
        text: 'No',
        value: 'no',
        sortable: false,
      },
      {
          text: 'Address',
          align: 'left',
          value: 'address',
      },
      { text: 'Longitude', value: 'longitude' },
      { text: 'Latitude', value: 'latitude' },
      { text: 'Created At', value: 'created_at' },
      { text: "Map", value: "map", sortable: false },
      { text: "Actions", value: "action", sortable: false },
    ],
    mapCreate: {
      style: "width: 100; height: 400px",
      center: {
        lat: -23.8511901,
        lng: 131.2038283,
      },
      zoom: 4,
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      marker: {},
      position: {}
    },
    mapEdit: {
      style: "width: 100; height: 400px",
      center: {
        lat: -23.8511901,
        lng: 131.2038283,
      },
      zoom: 4,
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      marker: {},
      position: {}
    },
		map: {
			name: "",
			longitude: "",
			latitude: "",
			style: "width: 200; height: 500px",
      center: {
      //   lat: -23.8511901,
      //   lng: 131.2038283,
      },
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      marker: {},
      position: {},
		},
		dataApi: [],
		showMap: false,
		dialog: false,
		editDialog: false,
    dialog2: false,
    index: -1,
		userData: {},
		valid: true,
		validEdit: true,
		create: {
			address: '',
			longitude: '',
			latitude: ''
		},
		edit: {
			id: '',
			address: '',
			longitude: '',
			latitude: ''
		},
    loadingAddr: false,
    loadingUpdate: false,
    loader: null,
    searchData: "",
    searchDataTimeout: null,
    deldialog: false,
    deleteTarget: null,
    popularAddressTotal: 0,
    footerProps: {
      itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
    },
    paginationOptions: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    },
  }),
  created() {
    this.token = this.$store.state.token;
    this.clientid = this.$store.state.clientid;
  },
  mounted() {
    this.getPopularAddressTotal();
    this.getData();
  },
  watch: {
    deldialog(show) {
      if (!show) {
        this.deleteTarget = null;
      }
    },
    "destination.search"() {
      clearTimeout(this.destination.timeout);
      if (this.destination.selected) {
        if (this.destination.search == this.destination.selected.address)
          return;
      }
      if (!this.destination.search) {
        // this.destination.selected = "";
        this.destination.locations = [];
        this.destination.loading = false;
        return;
      }
      if (!isNull(this.destination.search)) {
        
        this.destinationRequired = false;
      }
      this.destination.timeout = setTimeout(() => {
        this.handleSearchDestination(this.destination.search, this);
      }, 2e3);
    },
    "destination.selected"(value) {
      const geo = value;
      if (isNull(geo)) return;
      if(!isEmpty(value)) {
        const lat = parseFloat(geo.latitude);
        const lng = parseFloat(geo.longitude);
        this.mapCreate.position = { lng, lat };
        this.mapCreate.center = { lng, lat };
        this.mapCreate.zoom = 18;
        this.create.longitude = lng;
        this.create.latitude = lat;

      }
    },
    "destinationEdit.search"() {
      clearTimeout(this.destinationEdit.timeout);
      if (this.destinationEdit.selected) {
        if (this.destinationEdit.search == this.destinationEdit.selected.address)
          return;
      }
      if (!this.destinationEdit.search) {
        this.destinationEdit.selected = "";
        this.destinationEdit.locations = [];
        this.destinationEdit.loading = false;
        return;
      }
      if (!isNull(this.destinationEdit.search)) {
        this.destinationEditRequired = false;
      }
      this.destinationEdit.timeout = setTimeout(() => {
        this.handleSearchDestinationEdit(this.destinationEdit.search, this);
      }, 2e3);
    },
    "destinationEdit.selected"(value) {
      const geo = value;

      if (!geo) return;
      if (geo.type == "sd") {
        // const lat2 = parseFloat(this.map.oriPosition.lat);
        const lat = parseFloat(geo.lat);
        const lng = parseFloat(geo.lng);
        this.mapEdit.position = { lat, lng };
        this.mapEdit.center = { lat, lng };
        this.mapEdit.zoom = 18;
        this.edit.longitude = lng;
        this.edit.latitude = lat;

      } else if (geo.type == "geofence") {
        // const lat2 = parseFloat(this.mapEdit.oriPosition.lat);
        const lat = (parseFloat(geo.top) + parseFloat(geo.bottom)) / 2;
        const lng = (parseFloat(geo.left) + parseFloat(geo.right)) / 2;
        this.mapEdit.position = { lng, lat };
        this.mapEdit.center = { lng, lat };
        this.mapEdit.zoom = 18;
        this.edit.longitude = lng;
        this.edit.latitude = lat;
      } else {
        const lat = parseFloat(geo.latitude);
        const lng = parseFloat(geo.longitude);

        this.mapEdit.position = { lng, lat };
        this.mapEdit.center = { lng, lat };
        this.mapEdit.zoom = 18;
        this.edit.longitude = lng;
        this.edit.latitude = lat;
      }
    },
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
    searchData() {
      clearTimeout(this.searchDataTimeout)
      this.searchDataTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];
        this.getPopularAddressTotal();
        this.getData();
      }, 1e3)
    }
  },
  methods: {
    handleFocusDestination() {
      if (this.destination.search === "" || this.destination.search === null) {
        this.destination.locations = [];
      }
    },
    handleSearchDestinationEdit: async (  q, vm) => {
      if (vm.destinationEdit.loading) return;

      vm.destinationEdit.loading = true;

      let baseUrl = process.env.VUE_APP_CARPOOLING_URL.replace('carpooling', '');
      baseUrl = baseUrl.replace('_dev', '');
      const filterAu = process.env.VUE_APP_WEB != "fleetpooling";
      const queryAddress = qs.stringify({ query: q, key: '70hrLH@SZ&pa2g', filter_au: filterAu });
      const url = `${baseUrl}index.php/public_api/search_address_carpool?${queryAddress}`
      return vm.$http
        .get(url)
        .then(response => {
          if (response) {
            const { data } = response;
            let addressFormatted = [];
            let streetFormatted = [];

            if (data.hasOwnProperty("address")) {
              addressFormatted = data.address.map(p => {
                if (p.hasOwnProperty("id")) {
                  let streetType =
                    p.street_type === "Street" ? "St" : p.street_type;
                  let number =
                    p.number_last !== null
                      ? `${p.number_first}-${p.number_last}`
                      : p.number_first;

                  p.address = `${number} ${p.street_name} ${streetType}, ${
                    p.locality_name
                  }, ${p.state_name}, ${p.postcode}`;
                }
                return p;
              });
            }

            if (data.hasOwnProperty("street")) {
              streetFormatted = data.street.map(s => {
                if (s.hasOwnProperty("id")) {
                  s.address = `${s.street_name}, ${s.locality_name}, ${
                    s.state_name
                  }, ${s.postcode}`;
                }
                return s;
              });
            }

            if (Array.isArray(data)) {
              addressFormatted = data.map(p => ({
                longitude: p.lng,
                latitude: p.lat,
                address: p.address
              }));
            }

            vm.destinationEdit.locations = [
              ...addressFormatted,
              ...streetFormatted
            ];
          }
        })
        .then(() => (vm.destinationEdit.loading = false));
    },
    handleSearchDestination: async (q, vm) => {
      if (vm.destination.loading) return;

      vm.destination.loading = true;

      let baseUrl = process.env.VUE_APP_CARPOOLING_URL.replace('carpooling', '');
      baseUrl = baseUrl.replace('_dev', '');
      const filterAu = process.env.VUE_APP_WEB != "fleetpooling";
      const queryAddress = qs.stringify({ query: q, key: '70hrLH@SZ&pa2g', filter_au: filterAu });
      const url = `${baseUrl}index.php/public_api/search_address_carpool?${queryAddress}`
      return vm.$http
        .get(url)
        .then(response => {
          if (response) {
            const { data } = response;
            let addressFormatted = [];
            let streetFormatted = [];

            if (data.hasOwnProperty("address")) {
              addressFormatted = data.address.map(p => {
                if (p.hasOwnProperty("id")) {
                  let streetType =
                    p.street_type === "Street" ? "St" : p.street_type;
                  let number =
                    p.number_last !== null
                      ? `${p.number_first}-${p.number_last}`
                      : p.number_first;

                  p.address = `${number} ${p.street_name} ${streetType}, ${
                    p.locality_name
                  }, ${p.state_name}, ${p.postcode}`;
                }
                return p;
              });
            }

            if (data.hasOwnProperty("street")) {
              streetFormatted = data.street.map(s => {
                if (s.hasOwnProperty("id")) {
                  s.address = `${s.street_name}, ${s.locality_name}, ${
                    s.state_name
                  }, ${s.postcode}`;
                }
                return s;
              });
            }

            if (Array.isArray(data)) {
              addressFormatted = data.map(p => ({
                longitude: p.lng,
                latitude: p.lat,
                address: p.address
              }));
            }

            vm.destination.locations = [
              ...addressFormatted,
              ...streetFormatted
            ];
          }
        })
        .then(() => (vm.destination.loading = false));
    },
    handleFocusDestinationEdit() {
      if (this.destinationEdit.search === "" || this.destinationEdit.search === null) {
        this.destinationEdit.locations = [];
      }
    },
		save() {
      if (this.$refs.form.validate()) {
        this.loadingUpdate = true;
        this.loader = this.loadingUpdate;
        this.$store.dispatch('API_CALL', {
            $method: 'create_popular_address',
            $postData: {
							clientid: this.clientid,
							address: this.create.address,
							longitude: this.create.longitude,
							latitude: this.create.latitude,
            },
          })
          .then(
						(response) => {
							if(response.data.code == 200) {
                this.loadingUpdate = false;
                this.loader = this.loadingUpdate;
								this.$swal({
									icon: 'success',
                  title: response.data.data.message,
                })
                this.getPopularAddressTotal()
                this.getData()
								this.close();
              } else {
                this.loadingUpdate = false;
                this.loader = this.loadingUpdate;
                this.$swal({
                  icon: 'error',
                  title: response.data.data.message,
                })
              }
            })
      } else if (isNull(this.destination.search)) {
        this.destinationRequired = true;
        // this.destination.locations = [];
        // this.destination.selected = {};
      }
    },
    close() {
      this.createDialog = false;
      this.editDialog = false;
      this.mapCreate.position = null;
      this.$refs.form.reset();
    },
    closeEdit() {
      this.editDialog = false;
      this.mapCreate.position = null;
      this.destinationEdit.selected = null;
      this.$refs.formEdit.reset();
		},
		editItem(item){
			this.editDialog = true
			this.edit.address = item.address
			this.edit.id = item.id
			this.edit.longitude = item.longitude
      this.edit.latitude = item.latitude
      const lat = Number(item.latitude);
      const lng = Number(item.longitude);
      this.mapEdit.position = { lat, lng };
      this.mapEdit.center = { lat, lng };
      this.mapEdit.zoom = 18;
      this.destinationEdit.selected.address = item.address;

		},
    saveEdit() {
			if (this.$refs.formEdit.validate()) {
        this.loadingUpdate = true;
        this.loader = this.loadingUpdate;
        this.$store.dispatch('API_CALL', {
          $method: 'update_popular_address',
          $postData: {
            clientid: this.clientid,
            id: this.edit.id,
            address: this.edit.address,
            longitude: this.edit.longitude,
            latitude: this.edit.latitude,
          },
        })
        .then(
          (response) => {
            if(response.data.code == 200) {
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
              this.$swal({
                icon: 'success',
                title: response.data.data.message,
              })
              this.getPopularAddressTotal()
              this.getData()
              this.closeEdit();
            } else {
              this.$swal({
                icon: 'error',
                title: response.data.data.message,
              })
            }
          }
        )
      }
		},
		handleMap(item) {
			this.showMap = true
			this.map.name = item.address
			this.map.zoom = 18
			this.map.position = {
				"lat" : Number(item.latitude),
				"lng" :  Number(item.longitude),
      };
			this.map.center = {
				"lat" :  Number(item.latitude),
				"lng" :  Number(item.longitude),
			}
		},
    handleClickDialogOutside(){
      this.map.zoom = 0
    },
    declineItem(item) {
      this.deldialog = true;
      this.deleteTarget = item;
    },
    submitDeletePopular() {
      this.token = this.$store.state.token;
      return this.$store.dispatch('API_CALL', {
        $method: 'delete_popular_address',
        $postData: {
          id: this.deleteTarget.id
        },
      })
      .then(
        (response) => {
          this.deldialog = false;
          if(response.data.code == 200) {
            this.$swal({
              icon: 'success',
              title: response.data.data.message,
            })
            Promise.all([
              this.getPopularAddressTotal(),
              this.getData(),
            ]).then(() => {
              // Total data ada, tapi di page ini kosong
              if (this.popularAddressTotal > 0 && this.dataApi.length === 0) {
                // reset page ke page 1
                this.paginationOptions.page = 1
                // load ulang data
                this.getData();
              }
            })
          } else {
            this.$swal({
              icon: 'error',
              title: response.data.data.message,
            })
          }
        }
      )
    },
    getPopularAddressTotal() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      return this.$store.dispatch('API_CALL', {
        $method: 'get_popular_address_total',
        $postData: {
          clientid: this.$store.state.clientid,
          query: this.searchData
        },
      }).then((response) => {
        this.popularAddressTotal = parseInt(response.data.data.total);
      })
    },
    getData() {
      if (this.loadingAddr) return
      this.loadingAddr = true;
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;

      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by  = sortBy.length ? sortBy[0] : 'address';
      const sort_dir = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'asc';
      const offset   = (page - 1) * itemsPerPage;

      return this.$store.dispatch('API_CALL', {
        $method: 'get_popular_addresses',
        $postData: {
          clientid: this.$store.state.clientid,
          limit: itemsPerPage,
          offset,
          sort_by,
          sort_dir,
          query: this.searchData
        },
      }).then((response) => {
        this.loadingAddr = false;
				this.dataApi = response.data.data
			})
		},
		dateFormat (item) {
      if (item == null) return
      let date = null;
      if(item.hasOwnProperty("created_at")){
        date =  moment(item.created_at).format('D MMM YYYY HH:mm');
      }
      return date;
    },
    handleClickMap(point, create = true) {
      if (create) {
        this.create.latitude = point.latLng.lat();
        this.create.longitude = point.latLng.lng();

        this.mapCreate.position = {
          "lat" : point.latLng.lat(),
          "lng" :  point.latLng.lng(),
        };
        this.mapCreate.center = {
          "lat" :  point.latLng.lat(),
          "lng" :  point.latLng.lng(),
        }
      } else {
        this.edit.latitude = point.latLng.lat();
        this.edit.longitude = point.latLng.lng();

        this.mapEdit.position = {
          "lat" : point.latLng.lat(),
          "lng" :  point.latLng.lng(),
        };
        this.mapEdit.center = {
          "lat" :  point.latLng.lat(),
          "lng" :  point.latLng.lng(),
        }
      }
    },
    updatePaging(options) {
      this.getPopularAddressTotal();
      this.paginationOptions = options;
      this.getData();
    },
  },
  computed: {
    googles: gmapApi,
  }
};
</script>
<style>
.swal2-title {
  padding: 17px;
  display: block;
  margin: 22px;
  text-align: center;
  color: #61534e;
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-text {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
</style>
